import styled, { css } from 'styled-components';
import { POI } from '--root/static_types/messaging.types';
import { TextLeaf as TextLeafType } from '--root/static_types/slate/Shared';
import * as React from "react"

type LeafProps = TextLeafType & { poiType?: POI["poiType"] } & { onClick?: () => void }

export const Leaf = React.forwardRef((props: LeafProps, ref: React.Ref<HTMLElement>) => {
    return <StyledLeaf ref={ref as any} {...props} onClick={props.poiType === "link" ? undefined : props.onClick} as={props.poiType === "link" ? "a" : undefined} href={props.poiType === "link" ? props.text : undefined} />
})

export const StyledLeaf = styled.span<Partial<TextLeafType & { poiType?: POI["poiType"] }>>`
    color: ${p => p.theme.palette.text.primary};
    /* Bold */
    ${props => props.bold && css`
        font-weight: ${props => props.theme.typography.bold};
    `}

    /* Italic */
    ${props => props.italic && css`
        font-style: italic;
    `}

    /* Strike */
    ${props => props.strike && css`
        text-decoration: line-through;
    `}

    /* Inline Code */
    ${props => props.code && css`
        display: inline-block;
        ${props => props.theme.typography.code};
        color: ${props => props.theme.palette.text.primary};
        padding: ${props => props.theme.spacing(0, 0.5)};
        border-radius: ${props => props.theme.radius.small};
        border: 1px solid ${props => props.theme.palette.ui.border};
        background: ${props => props.theme.palette.background};
    `}

    /*Search Highlighting*/
    ${props => props.highlighter && css`
        background-color: ${props => props.theme.palette.primary.lighter};
        color: ${props => props.theme.palette.text.primary} !important;
    `}
    ${props => (props.poiType) && css`
        color: ${props.poiType === "link" ? props.theme.palette.text.link : props.theme.palette.text.asPrimaryColour};
        text-decoration: underline;
    `}
    ${props => props.onClick ? css`cursor: pointer;` : ""}
    ${props => props.highlightStart && css`
        padding-left: ${props => props.theme.spacing(.1)};
        border-radius: ${props.theme.radius.small} 0 0 ${props.theme.radius.small};
        background-color: ${props => props.theme.palette.primary.lighter};
    `}

    ${props => props.highlightBetween && css`
        background-color: ${props => props.theme.palette.primary.lighter};
    `}

    ${props => props.highlightEnd && css`
        padding-right: ${props => props.theme.spacing(.1)};
        border-radius: 0 ${props.theme.radius.small} ${props.theme.radius.small} 0;
        background-color: ${props => props.theme.palette.primary.lighter};
    `}
`;